// frontend/src/config/sharedOverlayLayers.js

/**
 * A global set of boundary, label, and road layers
 * that appear in your console logs for various Mapbox styles.
 *
 * Note: Some styles won't have all of these; you'll see warnings
 * like "Layer X not found on the map."
 */


// Labels (covering roads, POIs, water, airports, states, countries, etc.)
export const SHARED_LABELS = [
  "building-number-label",
  "road-label",
  "road-number-shield",
  "road-exit-shield",
  "waterway-label",
  "water-line-label",
  "water-point-label",
  "natural-line-label",
  "natural-point-label",
  "poi-label",
  "airport-label",
  "settlement-subdivision-label",
  "settlement-label",
  "state-label",
  "country-label",
  "golf-hole-label",
  "transit-label"
  // Add more "xxx-label" or "xxx-shield" if you see them in your style console
];
// Boundaries (including disputed or background variants, if present)
export const SHARED_BOUNDARIES = [
  "admin-0-boundary-bg",
  "admin-1-boundary-bg",
  "admin-0-boundary",
  "admin-1-boundary",
  "admin-0-boundary-disputed"
];

// Roads (including case layers, oneway arrows, pedestrian, minor/major, etc.)
export const SHARED_ROADS = [
  "road-pedestrian-case",
  "road-minor-case",
  "road-street-case",
  "road-secondary-tertiary-case",
  "road-primary-case",
  "road-major-link-case",
  "road-motorway-trunk-case",
  "road-construction",
  "road-path",
  "road-steps",
  "road-major-link",
  "road-pedestrian",
  "road-minor",
  "road-street",
  "road-secondary-tertiary",
  "road-primary",
  "road-motorway-trunk",
  "road-oneway-arrow-blue",
  "road-oneway-arrow-white",
  "road-rail",
  "road-rail-tracks",
  "road-minor-low",
  "road-street-low"
  // You can also add "bridge-*" and "tunnel-*" if you want to hide those too.
];
